import { render } from "./AccountCancelConfirm.vue?vue&type=template&id=b88ba388&scoped=true"
import script from "./AccountCancelConfirm.vue?vue&type=script&lang=js"
export * from "./AccountCancelConfirm.vue?vue&type=script&lang=js"

import "./AccountCancelConfirm.vue?vue&type=style&index=0&id=b88ba388&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b88ba388"]])

export default __exports__